import React from "react";
import { useAuth } from "../../context/AuthContext";
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";
import Header from "./Header";
import Footer from "./Footer";
// import translations from "../../utilities/translations";
import "../../styles/main.scss";

const Layout = ({ children, settings, pageData }) => {
  const { currentLanguage } = useAuth();
  // console.log(pageData, settings);

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      allStrapiSetting {
        nodes {
          main {
            id
            site_description
            site_short_title
            site_title
            logo {
              localFile {
                publicURL
              }
            }
          }
        }
      }
      allStrapiHeader {
        nodes {
          locale
          localizations {
            data {
              attributes {
                locale
                menu {
                  menuItem
                }
              }
            }
          }
          menu {
            menuItem
            page {
              slug
            }
          }
          info {
            strapi_component
            id
            contactInfo {
              email
              emailUrl
              phone
              phoneUrl
            }
          }
        }
      }
      allStrapiFooter {
        nodes {
          locale
          localizations {
            data {
              attributes {
                locale
              }
            }
          }
          footerMenu {
            ... on STRAPI__COMPONENT_SETTINGS_CONTACT_INFO {
              id
              strapi_component
              contactInfo {
                email
                emailUrl
                phone
                phoneUrl
              }
              title
            }
            ... on STRAPI__COMPONENT_SETTINGS_MAIN {
              id
              strapi_component
              logIn {
                btnLabel
              }
              logo {
                localFile {
                  publicURL
                }
              }
            }
            ... on STRAPI__COMPONENT_SETTINGS_SOCIAL {
              id
              strapi_component
              link
              icon {
                localFile {
                  publicURL
                }
              }
            }
          }
          footerMenuItems {
            menuItem
            page {
              slug
            }
          }
        }
      }
    }
  `);

  // console.log(currentLanguage, "currentLanguage");

  return (
    <>
      <Helmet defaultTitle={settings?.data?.PageMetaTitle || "Default Title"}>
        <link
          rel="stylesheet"
          href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css"
          integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T"
          crossorigin="anonymous"
        ></link>
      </Helmet>
      <>
        <div className="site">
          <Header
            // settings={data.allStrapiSetting.nodes[0].main}
            settings={
              currentLanguage === "el-GR"
                ? data.allStrapiSetting.nodes[0].main
                : data.allStrapiSetting.nodes[1].main
            }
            menu={
              currentLanguage === "el-GR"
                ? data.allStrapiHeader.nodes[0].menu
                : data.allStrapiHeader.nodes[1].menu
            }
            contactInfo={data.allStrapiHeader.nodes[0].info}
            pageData={pageData}
          />
          <main className="site-main">{children}</main>
          <Footer
            footerMenu={
              currentLanguage === "el-GR"
                ? data.allStrapiFooter.nodes[0]
                : data.allStrapiFooter.nodes[1]
            }
          />
        </div>
      </>
    </>
  );
};

export default Layout;
